import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { OrganizationActivationDialogData } from './models/organization-activation-dialog-data';

@Component({
    templateUrl: './organization-activation-dialog.html',
    styleUrls: ['./organization-activation-dialog.scss'],
    imports: [MatCardModule, MatButtonModule, MatDialogClose, MatFormFieldModule, MatSelectModule],
})
export class OrganizationActivationDialogComponent {
    dialogData: OrganizationActivationDialogData;

    constructor(
        public dialogRef: MatDialogRef<OrganizationActivationDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: OrganizationActivationDialogData
    ) {}

    // Changement d'organisation
    public onOrganizationSelected(event: MatSelectChange): void {
        this.data.selectedOrganization = event.value;
    }
}
